<template>
    <div class="wrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Catelog</el-breadcrumb-item>
        </el-breadcrumb>
        <el-carousel indicator-position="none" :autoplay="false" height="56.267vw" :loop="false">
            <el-carousel-item v-for="(item, index) in Images" :key="index">
                <img style="width: 100%; object-fit: cover;" v-lazy="item.imgPath" />
            </el-carousel-item>
        </el-carousel>
        <div class="down">
            <el-button type="danger" @click="downloadPdf" :disabled="isDownloading" round>Download PDF</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pdfBlob: null,
            isDownloading: false,
            Images: [
                { imgPath: require('../assets/imgs/catelog/1.jpg') },
                { imgPath: require('../assets/imgs/catelog/2.jpg') },
                { imgPath: require('../assets/imgs/catelog/3.jpg') },
                { imgPath: require('../assets/imgs/catelog/4.jpg') },
                { imgPath: require('../assets/imgs/catelog/5.jpg') },
                { imgPath: require('../assets/imgs/catelog/6.jpg') },
                { imgPath: require('../assets/imgs/catelog/7.jpg') },
                { imgPath: require('../assets/imgs/catelog/8.jpg') },
                { imgPath: require('../assets/imgs/catelog/9.jpg') },
                { imgPath: require('../assets/imgs/catelog/10.jpg') },
                { imgPath: require('../assets/imgs/catelog/11.jpg') },
                { imgPath: require('../assets/imgs/catelog/12.jpg') },
                { imgPath: require('../assets/imgs/catelog/13.jpg') },
                { imgPath: require('../assets/imgs/catelog/14.jpg') },
                { imgPath: require('../assets/imgs/catelog/15.jpg') },
                { imgPath: require('../assets/imgs/catelog/16.jpg') },
                { imgPath: require('../assets/imgs/catelog/17.jpg') },
                { imgPath: require('../assets/imgs/catelog/18.jpg') },
                { imgPath: require('../assets/imgs/catelog/19.jpg') },
                { imgPath: require('../assets/imgs/catelog/20.jpg') },
                { imgPath: require('../assets/imgs/catelog/21.jpg') },
                { imgPath: require('../assets/imgs/catelog/22.jpg') },
                { imgPath: require('../assets/imgs/catelog/23.jpg') },
                { imgPath: require('../assets/imgs/catelog/24.jpg') },
                { imgPath: require('../assets/imgs/catelog/25.jpg') },
                { imgPath: require('../assets/imgs/catelog/26.jpg') },
                { imgPath: require('../assets/imgs/catelog/27.jpg') },
                { imgPath: require('../assets/imgs/catelog/28.jpg') },
                { imgPath: require('../assets/imgs/catelog/29.jpg') },
                { imgPath: require('../assets/imgs/catelog/30.jpg') },
                { imgPath: require('../assets/imgs/catelog/31.jpg') },
                { imgPath: require('../assets/imgs/catelog/32.jpg') },
                { imgPath: require('../assets/imgs/catelog/33.jpg') },
                { imgPath: require('../assets/imgs/catelog/34.jpg') },
                { imgPath: require('../assets/imgs/catelog/35.jpg') },
                { imgPath: require('../assets/imgs/catelog/36.jpg') },
                { imgPath: require('../assets/imgs/catelog/37.jpg') },
                { imgPath: require('../assets/imgs/catelog/38.jpg') },
                { imgPath: require('../assets/imgs/catelog/39.jpg') },
                { imgPath: require('../assets/imgs/catelog/40.jpg') },
                { imgPath: require('../assets/imgs/catelog/41.jpg') },
                { imgPath: require('../assets/imgs/catelog/42.jpg') },
                { imgPath: require('../assets/imgs/catelog/43.jpg') },
                { imgPath: require('../assets/imgs/catelog/44.jpg') },
                { imgPath: require('../assets/imgs/catelog/45.jpg') },
                { imgPath: require('../assets/imgs/catelog/46.jpg') },
                { imgPath: require('../assets/imgs/catelog/47.jpg') },
                { imgPath: require('../assets/imgs/catelog/48.jpg') },
                { imgPath: require('../assets/imgs/catelog/49.jpg') },
                { imgPath: require('../assets/imgs/catelog/50.jpg') },
                { imgPath: require('../assets/imgs/catelog/51.jpg') },
                { imgPath: require('../assets/imgs/catelog/52.jpg') },
                { imgPath: require('../assets/imgs/catelog/53.jpg') },
                { imgPath: require('../assets/imgs/catelog/54.jpg') },
                { imgPath: require('../assets/imgs/catelog/55.jpg') },
                { imgPath: require('../assets/imgs/catelog/56.jpg') },
                { imgPath: require('../assets/imgs/catelog/57.jpg') },
                { imgPath: require('../assets/imgs/catelog/58.jpg') },
                { imgPath: require('../assets/imgs/catelog/59.jpg') },
                { imgPath: require('../assets/imgs/catelog/60.jpg') },
                { imgPath: require('../assets/imgs/catelog/61.jpg') },
                { imgPath: require('../assets/imgs/catelog/62.jpg') },
                { imgPath: require('../assets/imgs/catelog/63.jpg') },
                { imgPath: require('../assets/imgs/catelog/64.jpg') },
                { imgPath: require('../assets/imgs/catelog/65.jpg') },
                { imgPath: require('../assets/imgs/catelog/66.jpg') },
                { imgPath: require('../assets/imgs/catelog/67.jpg') },
                { imgPath: require('../assets/imgs/catelog/68.jpg') },
                { imgPath: require('../assets/imgs/catelog/69.jpg') },
                { imgPath: require('../assets/imgs/catelog/70.jpg') },
            ],
        };
    },
    methods: {
        async preloadPdf() {
            const response = await fetch('/2024 GiGwi Catalogue.pdf');
            if (response.ok) {
                this.pdfBlob = await response.blob();
            }
        },
        downloadPdf() {
            if (this.pdfBlob) {
                this.isDownloading = true;
                this.$notify.info({
                    title: 'Tip',
                    message: 'Preparing your download. This may take a few minutes.Please do not click repeatedly',
                    offset: 100,
                    duration: 0
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(this.pdfBlob);
                link.download = "GiGwi Catalogue.pdf";
                link.click();
                URL.revokeObjectURL(link.href); // 释放 URL 对象
                setTimeout(() => {
                    this.isDownloading = false;
                }, 5000);
            }
        }
    },
    mounted() {
        this.preloadPdf(); // 组件挂载时预加载 PDF
    }
};
</script>
<style scoped>
.wrapper {
    width: 100vw;
    margin: 0 auto 23.733vw;
}

.down {
    margin-top: 12.267vw;
    padding: 0 7.733vw;
}

::v-deep .el-button--danger {
    color: #FFF;
    background-color: #CA141D;
    border-color: #CA141D;
    width: 100%;
    border-radius: 5px;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>